module.exports = __webpack_public_path__ + "media/images/icons/outlined/left-square-21602272ef034a38e4621efe8ae21ac8.svg";